import { render, staticRenderFns } from "./Stranke.vue?vue&type=template&id=635bb1ad&"
import script from "./Stranke.vue?vue&type=script&lang=js&"
export * from "./Stranke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports